import { createFileRoute } from '@tanstack/react-router'

import { photosQuery } from '../lib/queries'
import type { PhotoAngle } from '../lib/types'
import { ANGLES, Photos } from '../screens/Photos'

type PhotosSearch = { angle?: PhotoAngle }

export const Route = createFileRoute('/photos')({
  validateSearch: (search: Record<string, unknown>): PhotosSearch => ({
    angle: ANGLES.find((angle) => angle === search.angle),
  }),
  loaderDeps: ({ search }) => ({ angle: search.angle ?? 'front' }),
  loader: ({ context, deps }) => context.queryClient.ensureQueryData(photosQuery(deps.angle)),
  component: Photos,
})
